import { plusDays, weekStartOf } from '@/helpers/dates'

// The production day calendar always has four weeks loaded around the anchor
// week (last week, this week and the two after it) and shows all of them or
// one span. `start` is the first shown week's offset from the anchor week,
// `focus` the week the month label and arrows speak of (the anchor week when
// everything is shown).
export const CALENDAR_SPANS = [
  { value: 'all', label: 'All 4 weeks', start: -7, focus: 0, days: 28 },
  { value: 'past', label: 'Past week', start: -7, focus: -7, days: 7 },
  { value: 'current', label: 'Current week', start: 0, focus: 0, days: 7 },
  { value: 'future', label: '2 future weeks', start: 7, focus: 7, days: 14 }
]

export const DEFAULT_CALENDAR_SPAN = 'all'

export const CALENDAR_SPAN_STORAGE_KEY = 'productionDayCalendar/span'

const spanByValue = value => CALENDAR_SPANS.find(span => span.value === value)

// The last span the merchant picked in this browser, or the default.
export function readCalendarSpan() {
  try {
    const stored = localStorage.getItem(CALENDAR_SPAN_STORAGE_KEY)
    return spanByValue(stored) ? stored : DEFAULT_CALENDAR_SPAN
  } catch {
    return DEFAULT_CALENDAR_SPAN
  }
}

// Remembered per browser so the page reopens on the same span. Storage can be
// unavailable (private mode, blocked site data); the choice still applies.
export function writeCalendarSpan(value) {
  try {
    localStorage.setItem(CALENDAR_SPAN_STORAGE_KEY, value)
  } catch {
    // nothing to do: the selection lives on in the page
  }
}

// The four weeks loaded around the anchor's week, Sunday to Saturday.
export function calendarWindow(anchor) {
  const start = plusDays(weekStartOf(anchor), -7)
  return Array.from({ length: 28 }, (_, index) => plusDays(start, index))
}

const spanOrDefault = value => spanByValue(value) || spanByValue(DEFAULT_CALENDAR_SPAN)

// The dates the chosen span shows, out of the anchor's four-week window.
export function calendarSpanDates(anchor, value) {
  const span = spanOrDefault(value)
  const start = plusDays(weekStartOf(anchor), span.start)
  return Array.from({ length: span.days }, (_, index) => plusDays(start, index))
}

// The Sunday of the week the calendar labels for the chosen span.
export function calendarFocusWeek(anchor, value) {
  return plusDays(weekStartOf(anchor), spanOrDefault(value).focus)
}
